/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Send: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="send" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M170 226.6666666666668V1133.3333333333333L1246.6666666666665 680L170 226.6666666666668zM283.3333333333333 396.6666666666668L954.8333333333334 680L283.3333333333333 963.3333333333334V765L623.3333333333333 680L283.3333333333333 595V396.6666666666668z" : "M136 181.3333333333333V906.6666666666666L997.3333333333334 544L136 181.3333333333333zM226.6666666666667 317.3333333333333L763.8666666666668 544L226.6666666666667 770.6666666666666V612L498.6666666666667 544L226.6666666666667 476V317.3333333333333z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Send.displayName = `Blueprint5.Icon.Send`;
export default Send;
